export const WIDGET_TYPES = [
  'table',
  'chart',
  'My Widget',
  'iframe',
  'infoBox',
  'TestimonialsCarousel',
  'galleryGrid',
  'list',
  'ExtendedGallery',
  'chart__pie',
  'chart__doughnut',
  'chart__horizontalBar',
  'chart__bar',
  'chart__line',
  'chart__stepLine',
  'chart__bubble',
  'chart__scatter',
  'chart__stackSide',
  'chart__stacked',
  'chart__stackLine',
  'form__1col',
  'form__2col',
  'titanForm',
  'Widget',
  'PowerTable',
  'TreeView',
  'TablePricing',
  'ProductCard',
  'Scheduler',
  'Spreadsheet',
  'Ticker',
  'Form',
]
